// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TopBar_TopBar__HIyl1 {
  position: relative;
  width: 100%;
  height: 8vh;
  border-bottom: 1px solid #ECECEC;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 1rem;
}

.TopBar_Logo__AFgQB {
  height: 100%;
}

.TopBar_LogoutButton__7P87b {
  color: black;
  font-size: 0.85rem;
  font-weight: bold;
}

.TopBar_UserContainer__8o0os {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 1rem;
}

.TopBar_Separator__LS232 {
  height: 2.5rem;
  width: 1px;
  background-color: #ECECEC;
}

.TopBar_NotificationContainer__DxNbk {
  position: relative;
}

.TopBar_NotificationBadge__AH-0e {
  background-color: red;
  color: white;
  border-radius: 50%;
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
  font-weight: bold;
}

.TopBar_NotificationBell__7onGx {
  cursor: pointer;
  padding: 0.5rem;
  border-radius: 8px;
  transition: background-color 0.2s;
  display: flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 1rem;
  font-weight: 500;
}
.TopBar_NotificationBell__7onGx:hover {
  background-color: #f0f0f0;
}
.TopBar_NotificationBell__7onGx i {
  font-size: 1.2rem;
  color: #666;
}

@media screen and (max-width: 768px) {
  .TopBar_TopBar__HIyl1 {
    height: 60px;
    padding: 0.5rem 1rem;
  }
  .TopBar_Logo__AFgQB {
    height: 60%;
  }
  .TopBar_NotificationContainer__DxNbk {
    display: none;
  }
  .TopBar_LogoutButton__7P87b {
    padding: 0.75rem;
  }
  .TopBar_LogoutButton__7P87b .TopBar_p-button-label__hlgTJ {
    display: none;
  }
  .TopBar_LogoutButton__7P87b .TopBar_pi__JGPp9 {
    font-size: 1.25rem;
  }
  .TopBar_UserContainer__8o0os {
    gap: 0.75rem;
    font-size: 1.1rem;
  }
  .TopBar_Separator__LS232 {
    height: 2rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/features/common/components/TopBar/TopBar.module.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,WAAA;EACA,WAAA;EACA,gCAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,mBAAA;EACA,aAAA;AACF;;AAEA;EACI,YAAA;AACJ;;AAEA;EACI,YAAA;EACA,kBAAA;EACA,iBAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,mBAAA;EACA,SAAA;AACJ;;AACA;EACI,cAAA;EACA,UAAA;EACA,yBAAA;AAEJ;;AACA;EACE,kBAAA;AAEF;;AAAA;EACE,qBAAA;EACA,YAAA;EACA,kBAAA;EACA,uBAAA;EACA,kBAAA;EACA,iBAAA;AAGF;;AADA;EACE,eAAA;EACA,eAAA;EACA,kBAAA;EACA,iCAAA;EACA,aAAA;EACA,mBAAA;EACA,WAAA;EACA,eAAA;EACA,gBAAA;AAIF;AAFE;EACE,yBAAA;AAIJ;AADE;EACE,iBAAA;EACA,WAAA;AAGJ;;AACA;EACE;IACE,YAAA;IACA,oBAAA;EAEF;EACA;IACE,WAAA;EACF;EAEA;IACE,aAAA;EAAF;EAGA;IAIE,gBAAA;EAJF;EACE;IACE,aAAA;EACJ;EAGE;IACE,kBAAA;EADJ;EAKA;IACE,YAAA;IACA,iBAAA;EAHF;EAMA;IACE,YAAA;EAJF;AACF","sourcesContent":[".TopBar {\n  position: relative;\n  width: 100%;\n  height: 8vh; \n  border-bottom: 1px solid #ECECEC;\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1rem;\n}\n\n.Logo{\n    height: 100%;\n}\n\n.LogoutButton{\n    color: black;\n    font-size: 0.85rem;\n    font-weight: bold;\n}\n\n.UserContainer{\n    display: flex;\n    flex-direction: row;\n    align-items: center;\n    gap: 1rem;\n}\n.Separator{\n    height: 2.5rem;\n    width: 1px;\n    background-color: #ECECEC;\n}\n\n.NotificationContainer {\n  position: relative;\n}\n.NotificationBadge{\n  background-color: red;\n  color: white;\n  border-radius: 50%;\n  padding: 0.25rem 0.5rem;\n  font-size: 0.75rem;\n  font-weight: bold;\n}\n.NotificationBell {\n  cursor: pointer;\n  padding: 0.5rem;\n  border-radius: 8px;\n  transition: background-color 0.2s;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 1rem;\n  font-weight: 500;\n  \n  &:hover {\n    background-color: #f0f0f0;\n  }\n\n  i {\n    font-size: 1.2rem;\n    color: #666;\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .TopBar {\n    height: 60px;\n    padding: 0.5rem 1rem;\n  }\n\n  .Logo {\n    height: 60%;\n  }\n\n  .NotificationContainer {\n    display: none;\n  }\n\n  .LogoutButton {\n    .p-button-label {\n      display: none;\n    }\n    padding: 0.75rem;\n    \n    .pi {\n      font-size: 1.25rem;\n    }\n  }\n\n  .UserContainer {\n    gap: 0.75rem;\n    font-size: 1.1rem;\n  }\n\n  .Separator {\n    height: 2rem;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"TopBar": `TopBar_TopBar__HIyl1`,
	"Logo": `TopBar_Logo__AFgQB`,
	"LogoutButton": `TopBar_LogoutButton__7P87b`,
	"UserContainer": `TopBar_UserContainer__8o0os`,
	"Separator": `TopBar_Separator__LS232`,
	"NotificationContainer": `TopBar_NotificationContainer__DxNbk`,
	"NotificationBadge": `TopBar_NotificationBadge__AH-0e`,
	"NotificationBell": `TopBar_NotificationBell__7onGx`,
	"p-button-label": `TopBar_p-button-label__hlgTJ`,
	"pi": `TopBar_pi__JGPp9`
};
export default ___CSS_LOADER_EXPORT___;
